import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateBookMonthMutation } from "@modules/bookMonths/services/mutations";
import { BookMonthFormValues, bookMonthSchema } from "@modules/bookMonths/validations";
import { listBookMonthsQueryKey } from "@modules/bookMonths/services/queries/listBookMonths/query";

export function useCreateBookMonthModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<BookMonthFormValues>({
    resolver: zodResolver(bookMonthSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateBookMonthMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: listBookMonthsQueryKey, refetchType: "all" });
      open?.({ type: "success", message: translate("v2/bookstore/book_month_admin.success.create") });
      onComplete?.();
      modalRef.current?.close();
      methods.reset();
    },
  });

  return { methods, mutateAsync, isPending };
}
